import { oneOf } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { MessageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import DOMAINS from '../domains';
function format(value, options) {
    const { name } = options;
    const prefix = DOMAINS[name];
    return value ? MessageService.translate(`${prefix}/${value}`.toLocaleLowerCase()) : '';
}
format.prototype.optionTypes = {
    name: oneOf(Object.keys(DOMAINS))
};
function getPattern() {
    throw new Error('Method not implemented.');
}
function validate(value) {
    return [{ valid: !!value }];
}
function parse(value) {
    return value;
}
const formatterFunctions = {
    format,
    getPattern,
    parse,
    validate,
};
export default ModelService.registerFormatter('domain', formatterFunctions);
//# sourceMappingURL=domain-formatter-util.js.map